<template>
  <div :style="`position: relative;width:${dispW}px;height:${dispH}px`" id="cornea-param">
    <div>
      <div :style="`position: absolute;left:${dispW - 120 - 10}px;top:40px`">
        <AxisIndication
          v-if="false && !rightsider.isMapBoolen && !isDiff"
          :dispW="isDiff ? 150 : 120"
          :dispH="isDiff ? 150 : 120"
          :rightsider="rightsider"
          :axisFlat="axisFlat"
          :axisSteep="axisSteep"
        ></AxisIndication>
      </div>
    </div>
    <br />
    <div
      class="param-label-value"
      v-for="(item, index) in paramValues"
      :key="index"
      :style="`color:${item.lang === 'langcfg.txtDiffHightD8' ? 'white' : item.color}`"
    >
      <div class="param-label">{{ item.lang ? $t(item.lang) : item.label }}:</div>
      <div class="param-value" @click="paramClick(item)">
        {{ isLanguage === "it" ? "" : "&nbsp;"
        }}<span
          :style="`${getValueStyle(item)};padding:1px 1px 2px 10px;${item.lang === 'langcfg.txtDiffHightD8' ? 'cursor:pointer;' : ''}`"
          >{{ item.value }}</span
        >
        <el-tooltip
          v-if="item.lang === 'langcfg.txtDiffHightD8' && item.color !== 'white'"
          v-model="showDiff8Tip"
          :content="$t('langcfg.txtFitValue')"
          manual
          placement="bottom"
          popper-class="tip"
        >
          <i
            class="el-icon-warning-outline"
            :style="`margin-left:${isLanguage === 'it' ? '2px' : '5px'};color:${item.color};height:23px;${item.lang === 'langcfg.txtDiffHightD8' ? 'cursor:pointer;' : ''}`"
          ></i>
        </el-tooltip>
      </div>
    </div>
  </div>
</template>
<script>
import AxisIndication from "./AxisIndication";
import { mapGetters } from "vuex";
import {
  cartesian2polar,
  isDataValid,
  isDefined,
  MAJMEDIANMODES,
  FLATCOLOR,
  STEEPCOLOR
} from "../shared/index";
import { paramNormal } from "../../shared/filters";
import { TOPOGRAPHYEVENTS } from "../shared/events";
import { BASEPARAMS } from "../dataGetters/params";
import EVENTS from "../../bus";
export default {
  name: "CorneaParam",
  data() {
    return {
      circleSize: 140,
      axisSteep: 60,
      axisFlat: 30,
      paramValues: [],
      showDiff8Tip: false,
      hideTipTimeout: null,
      isLanguage: ""
    };
  },
  mounted() {
    if (!this.mapValues || !this.mapValues.params) {
      this.normalData(BASEPARAMS);
    }
    this.isLanguage = window.settings.language;
    this.$bus.$on(EVENTS.showSettings, () => {
      this.showDiff8Tip = false;
    });
  },
  updated() {
    this.isLanguage = window.settings.language;
  },
  watch: {
    mapValues: {
      handler() {
        this.normalData(this.mapValues.params);
      },
      deep: true,
      immediate: true
    },
    dataShowSettings() {
      this.$bus.$emit(TOPOGRAPHYEVENTS.medianModeChanged);
      this.normalData(this.mapValues.params);
    },
    subPage() {
      this.showDiff8Tip = false;
    },
    showDiff8Tip(newVal) {
      if (newVal === true && !this.hideTipTimeout) {
        this.hideTipTimeout = setTimeout(() => {
          this.showDiff8Tip = false;
        }, 5000);
      } else if (this.hideTipTimeout) {
        clearTimeout(this.hideTipTimeout);
        this.hideTipTimeout = null;
      }
    }
  },
  methods: {
    normalData(params) {
      if (!isDefined(params)) return;
      this.paramValues = [];
      let obj = {
        label: `K1 / ${this.RhRfTitle}`,
        value: `${paramNormal(params["K1"].value)}D @ ${paramNormal(params["AxisFlat"].value)}° / ${this.getRhRf(params)}mm`,
        color: FLATCOLOR
      };
      this.paramValues.push(obj);
      obj = {
        label: `K2 / ${this.RvRsTitle}`,
        value: `${paramNormal(params["K2"].value)}D @ ${paramNormal(params["AxisSteep"].value)}° / ${this.getRvRs(params)}mm`,
        color: STEEPCOLOR
      };
      this.paramValues.push(obj);
      obj = {
        label: `Km / Rm`,
        value: `${paramNormal(params["Km"].value)}D / ${paramNormal(params["Rm"].value)}mm`
      };
      this.paramValues.push(obj);
      let astig = -1000;
      let axis = -1000;
      if (isDataValid(params["K1"].value) && isDataValid(params["K2"].value)) {
        astig = params["K1"].value - params["K2"].value;
      }
      if (isDataValid(params["AxisFlat"].value) && isDataValid(params["AxisSteep"].value)) {
        axis = params["AxisFlat"].value;
      }
      obj = {
        label: `Astig`,
        value: `${paramNormal(astig)}D @ ${paramNormal(axis)}°`
      };
      this.paramValues.push(obj);
      obj = {
        label: this.eccPEQTitle,
        value: `${paramNormal(params["EccPEQ"].value)}`
      };
      this.paramValues.push(obj);
      obj = {
        lang: "langcfg.txtDiffHightD8",
        label: `${this.$t("langcfg.txtDiffHightD8")}:`,
        value: `${paramNormal(params["elevDiff4mm"].value, { fixed: 0 })}μm`,
        // 模拟值置灰色
        // 20231201市场部要求更改为白色
        // 20231212外贸要求更改为灰色
        color: params["elevDiff4mm"].analog === true ? "gray" : "white"
      };
      this.paramValues.push(obj);
      obj = {
        label: "Kmax / Rmin",
        value: `${paramNormal(params["Kmax"].value)}D / ${paramNormal(params["Rmin"].value)}mm ( ${this.getCartesianPolar(params, "RminX", "RminY")} )`,
        // value: `${45.1}D / ${7.45}mm (2.74mm @ 232)°`,
        isLong: true
      };

      this.paramValues.push(obj);

      // obj = {
      //   label: `SRI:`,
      //   value: `${paramNormal(params['SRI'].value)}`,
      //   bgColor: getKeraColor(params['SRI'].value, 'SRI')
      // }
      // this.paramValues.push(obj)
      // obj = {
      //   label: `SAI:`,
      //   value: `${paramNormal(params['SAI'].value)}`,
      //   bgColor: getKeraColor(params['SAI'].value, 'SAI')
      // }
      // this.paramValues.push(obj)
      // obj = {
      //   label: `IS:`,
      //   value: `${paramNormal(params['IS'].value)} D`,
      //   bgColor: getKeraColor(params['IS'].value, 'IS')
      // }
      // this.paramValues.push(obj)
      // obj = {
      //   label: `${this.$t('langcfg.txtPupilDiameter')}:`,
      //   value: `${paramNormal(params['PupilDia'].value)} mm`
      // }
      // this.paramValues.push(obj)
      // obj = {
      //   label: `${this.$t('langcfg.txtPupilCenter')}:`,
      //   value: `${this.getCartesianPolar(params, 'PupilCenterX', 'PupilCenterY')}`
      // }
      // this.paramValues.push(obj)
      window.paramValues = this.paramValues;
      // obj = {
      //   label: 'Cornea Center:',
      //   value: `${paramNormal(params['LimbusCenterZ'].value)} μm (${this.getCartesianPolar(params, 'LimbusCenterX', 'LimbusCenterY')})`
      // }
      // this.paramValues.push(obj)
    },
    getValueStyle(item) {
      let style = "";
      if (isDefined(item.bgColor)) {
        style += `background:${item.bgColor}`;
      }
      if (isDefined(item.color)) {
        style += `;color:${item.color}`;
      }
      return style;
    },
    getRhRf(params) {
      return paramNormal(this.dataShowSettings.isRhRv ? params["Rh"].value : params["Rf"].value);
    },
    getRvRs(params) {
      return paramNormal(this.dataShowSettings.isRhRv ? params["Rv"].value : params["Rs"].value);
    },
    getCartesianPolar(params, keyX, keyY) {
      if (this.dataShowSettings.isCartesian) {
        return `${paramNormal(params[keyX].value)}mm, ${paramNormal(params[keyY].value)}mm`;
      } else {
        if (isDataValid(params[keyX].value) && isDataValid(params[keyY].value)) {
          let { dist, angle } = cartesian2polar(params[keyX].value, params[keyY].value);
          return `${paramNormal(dist)}mm @ ${paramNormal(angle, { fixed: 0, rpText: "--" })}°`;
        } else {
          return `--mm @ --°`;
        }
      }
    },
    paramClick(item) {
      if (item.lang === "langcfg.txtDiffHightD8" && item.color !== "white") {
        this.showDiff8Tip = !this.showDiff8Tip;
      }
    }
  },
  components: {
    AxisIndication
  },
  computed: {
    ...mapGetters(["dataShowSettings"]),
    RhRfTitle() {
      return this.dataShowSettings.isRhRv ? "Rh" : "Rf";
    },
    RvRsTitle() {
      return this.dataShowSettings.isRhRv ? "Rv" : "Rs";
    },
    eccPEQTitle() {
      let title = "ecc";
      let mode = this.dataShowSettings.medianMode;
      switch (mode) {
        case MAJMEDIANMODES.ecc:
          title = `ecc (${this.dataShowSettings.mm}mm)`;
          break;
        case MAJMEDIANMODES.E:
          title = `E (${this.dataShowSettings.mm}mm)`;
          break;
        case MAJMEDIANMODES.P:
          title = `P (${this.dataShowSettings.mm}mm)`;
          break;
        case MAJMEDIANMODES.Q:
          title = `Q-val (${this.dataShowSettings.mm}mm)`;
          break;
        default:
          break;
      }
      return title;
    }
  },
  props: {
    rightsider: {
      type: Object,
      default: () => {
        return {
          visible: true,
          isMapBoolen: false,
          isScaleBoolen: true,
          isImageBoolen: false,
          isDiff: false
        };
      }
    },
    isDiff: {
      type: Boolean,
      default: false
    },
    dispW: {
      type: Number,
      default: 500
    },
    dispH: {
      type: Number,
      default: 500
    },
    indexInForm: {
      type: Number,
      default: -1
    },
    mapValues: {
      type: Object
    },
    subPage: ""
  },
  destroyed() {
    this.showDiff8Tip = false;
    this.$bus.$off(EVENTS.showSettings);
  }
};
</script>

<style scoped>
.param-label-value {
  width: 100%;
  text-align: left;
  padding-left: 6px;
  margin-top: 15px;
  line-height: 40px;
}
.param-value {
  /* border: 1px gray solid; */
  line-height: 20px;
  display: inline;
}

.param-label,
.param-value {
  font-size: 23px;
  display: inline-flex;
}
</style>



// WEBPACK FOOTER //
// src/topography/components/CorneaParam.vue